import {createEntityService} from 'utils/createEntityService';
import {Service} from '../types/service';

export const ServicesService = createEntityService<Service>({
  baseUrl: 'api/v1/services',
  entityName: 'service',
});
